import { ItemLayer } from '.';
import * as marietta from '../..';

export default class GroupItemLayer extends ItemLayer {
  childList: marietta.webcad.item.MonicaObject[]&marietta.webcad.item.GroupItem[];

  /**
     * アイテムパーツ作成
     */
  addParts(item) {
    this.spt.addChild(item.spt);

    // アイテム一覧に追加
    this.childList.push(item);
  }

  /**
     * 全てのアイテムの移動
     * @moveX Number X軸移動距離
     * @moveY Number Y軸移動距離
     * */
  moveAllItems(moveX: number, moveY: number): void {
    let target: marietta.webcad.item.GroupItem;
    for (let i: number = 0; i < this.childList.length; i += 1) {
      target = this.childList[i] as marietta.webcad.item.GroupItem;
      target.spt.x += moveX;
      target.spt.y += moveY;
      target.spt.update();
    }
  }
}
